import PartnerTutorialsInterstitial from './PartnerTutorialsInterstitial';

export default PartnerTutorialsInterstitial;
